import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export function Navbar() {
  const [open, setOpen] = React.useState(false);
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-stone-50/85 border-b border-stone-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-16">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2">
          <span className="inline-block w-2 h-2 bg-emerald-900 rounded-full" />
          <span className="font-heading text-lg tracking-tight text-stone-900">Physiofit<span className="text-emerald-900">.</span>studio</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-200 ${
                  isActive ? "text-emerald-900" : "text-stone-600 hover:text-stone-900"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/book"
            data-testid="nav-book"
            className="ml-2 inline-flex items-center px-5 py-2 rounded-full bg-emerald-900 text-stone-50 text-sm font-medium hover:bg-emerald-950 transition-colors duration-200"
          >
            Book appointment
          </Link>
        </nav>
        <button
          className="md:hidden text-stone-800"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-stone-200 bg-stone-50" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className="text-stone-700 py-1"
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/book"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-book"
              className="mt-2 inline-flex items-center justify-center px-5 py-2.5 rounded-full bg-emerald-900 text-stone-50 text-sm font-medium"
            >
              Book appointment
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}

export function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-stone-200 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="inline-block w-2 h-2 bg-emerald-900 rounded-full" />
            <span className="font-heading text-lg tracking-tight text-stone-900">Physiofit<span className="text-emerald-900">.</span>studio</span>
          </div>
          <p className="mt-4 max-w-md text-stone-600 leading-relaxed">
            Restore your health, rebuild your strength, renew your life. Evidence-based physiotherapy, rehab, and fitness in the heart of T. Nagar.
          </p>
        </div>
        <div>
          <div className="eyebrow">Visit</div>
          <p className="mt-3 text-stone-700 leading-relaxed">
            New No. 128<br />N Usman Road, T. Nagar<br />Chennai - 600017
          </p>
        </div>
        <div>
          <div className="eyebrow">Contact</div>
          <p className="mt-3 text-stone-700">
            <a href="tel:7200831203" className="hover:text-emerald-900" data-testid="footer-phone">+91 7200831203</a>
          </p>
          <p className="mt-2 text-stone-500 text-sm">Open 7 days a week<br />10:00 AM – 7:00 PM</p>
        </div>
      </div>
      <div className="border-t border-stone-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between text-xs text-stone-500">
          <span>© {new Date().getFullYear()} Physiofit Studio. All rights reserved.</span>
          <Link to="/admin/login" data-testid="admin-link" className="hover:text-emerald-900">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
